export default __webpack_public_path__ + "static/BAP_6288_rgb_fine-4c540fa223e5dae44597deb19e5e68be.jpg";